import { PanelPlacement } from '@ContractBuilder/hooks';

interface PlacementFlags {
  isLeftSidePlacement: boolean;
  isRightSidePlacement: boolean;
}

export const getPlacementFlags = (placement: PanelPlacement, isInSplitMode = false): PlacementFlags => ({
  isLeftSidePlacement: placement === PanelPlacement.Left && !isInSplitMode,
  isRightSidePlacement: placement === PanelPlacement.Right,
});
